export const CashBookTypes = {
    GET_CASHBOOK:'GET_CASHBOOK',
    GET_CASHBOOK_TOTAL:'GET_CASHBOOK_TOTAL',
}